import { useContext } from "react";
import { CluesContext } from ".";

export default function useClues() {
    const context = useContext(CluesContext);

    if (!context) {
        throw new Error("useClues must be used within a CluesProvider");
    }

    return context;
}